<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="poolsList"
      :items="poolsList"
      :fields="poolsFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>

    <b-modal size="lg" ref="addProfile" hide-footer :title="$t('DHCP pool')">
      <formAddPool
      @hideAddPool="hideAddPool"
      :currentRowPool="currentRowPool"
      :isEdit="isEdit"/>
    </b-modal>
  </div>
</template>

<script>
import formAddPool from './formAdd.vue'

export default {
  components: {
    formAddPool
  },
  data () {
    return {
      isEdit: null,
      currentRowPool: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      poolsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('DHCP pool`s name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.currentRowPool = null
      this.isEdit = false
      this.$refs.addProfile.show()
    },
    hideAddPool () {
      this.$refs.addProfile.hide()
    },
    editItem (item) {
      this.currentRowPool = JSON.parse(JSON.stringify(item))
      this.isEdit = true
      this.$refs.addProfile.show()
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "DHCP pool"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Inventory/DELETE_DHCP_POOLS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Inventory/GET_DHCP_POOLS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    poolsList () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Inventory/DHCP_POOLS']))
      for (let el of copy) {
        el.name = el.gateway + '/' + el.netmask
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Inventory/GET_DHCP_POOLS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/dhcpPools/main.vue